import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseSearchForm } from '@shared/ui/base-search-form';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { UiColumn } from '@shared/ui/ui-column';
import { TextAreaControl } from '@shared/ui/controls/textarea-control.model';
import { ViewRowControl } from '@shared/ui/controls/view-row-control.model';
import { ToggleControl } from '../../../shared/ui/controls/toggle-control.model';
import { TextControl } from '../../../shared/ui/controls/text-control.model';
import { ItemSearchResult } from '@shared/interfaces/gridrows/item-search-result.interface';
import { SearchGridComponent } from '../../../shared/components/grid/search-grid.component';
import { ToolBarComponent } from '@progress/kendo-angular-toolbar';
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { BenchTemplateStatus, SecurityRole } from '../../../shared/literals/shared.literal';
import { AuthUserSearchResult } from '../../../shared/interfaces/gridrows/auth-user-search-result.interface';
import { BenchTemplateSearchResult } from '../../../shared/interfaces/gridrows/bench-template.interface';
import { ReadOnlyIf, VisibleProperty } from '../../../shared/ui/control-options/control-option.interface';
import { BenchTemplateStatusSelect } from '../../../shared/ui/select-controls/bench-template-status-select.model';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { ClientEngineerSelect } from '../../../shared/ui/select-controls/client-engineer-select.model';
import { AuthUserFilter } from '../../../shared/interfaces/select-filters/auth-user-filter.interface';


@Component({
    selector: 'app-bench-template-list',
    templateUrl: './bench-template-list.component.html',
    styleUrls: ['./bench-template-list.component.css'],
    standalone: false
})
export class BenchTemplateListComponent extends BaseSearchForm<BenchTemplateSearchResult> implements OnInit {

  @ViewChild(SearchGridComponent) grid: SearchGridComponent;
  @ViewChild('toolbar') bar: ToolBarComponent;

  organizationId: Number | null;

  @Input() items: ToolbarItem[];

  ngOnInit(): void {

    var session = this.auth.getSession();

    this.organizationId = Number(session?.organizationId);

    //var toolbarAddNew: ToolbarItem = {
    //  text: 'Add Customer',
    //  icon: faPlus,
    //  hasMultiple: false,
    //  cssClass: 'success',
    //  action: () => { this.redirectToNewCustomer(); }
    //};


    this.toolbarItems.unshift();
  }
  constructor(private router: Router, private auth: AuthenticationService) {
    super();
    this.name = "Bench Template";
    this.apiController = "BenchTemplate";
    this.keyFieldName = "id";
    this.initializeUiControls();

    this.setGridSettings();
  }
  override initializeUiControls() {

    var session = this.auth.getSession();

    const view = new ViewControl("");

    const search = new UiGroupControl("", "Search");

    const statusSelect = new BenchTemplateStatusSelect("benchTemplateStatusId", "Status", null);

    var clientEngineerFilters: AuthUserFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    var clientEgineerDefaultValue: any = {};
    if (session?.securityRoleId == SecurityRole.Engineer || session?.securityRoleId == SecurityRole.GeneralEngineerUser) {
      clientEgineerDefaultValue = { id: session.userId, email: session.username };
    } else {
      clientEgineerDefaultValue = null;
    }

    const clientEngineerSelect = new ClientEngineerSelect("clientEngineerId", "Client Engineer", clientEgineerDefaultValue);
    clientEngineerSelect.filters = clientEngineerFilters;

    if (session?.securityRoleId == SecurityRole.Engineer || session?.securityRoleId == SecurityRole.GeneralEngineerUser) {
      clientEngineerSelect.addOption(new ReadOnlyIf(() => { return true }));
    }

    const isActive = new ToggleControl("isActive", "Is Active?", true);

    var row = new ViewRowControl();
    row.controls.push(isActive, statusSelect, clientEngineerSelect);

    search.rows.push(row);
    view.controls.push(search);

    this.views.push(view);
  }

  setGridSettings(): void {
    this.gridSettings = {
      gridName: "BenchTemplateSearch_Grid",
      showSubGrid: false,
      preloadData: true,
      columns: this.getColumns(),
      styleRow: (context: RowClassArgs) => { return this.getColumnStyleRowFormatting(context) }
    };
  }

  getColumnStyleRowFormatting = (context: RowClassArgs) => {
    if (context.dataItem != null) {
      if (context.dataItem.benchTemplateStatusId == Number(BenchTemplateStatus.Pending)) {
        return { pendingBenchTemplate: true };
      }
    }

    return { pendingBenchTemplate: false };
  }

  private getColumns(): UiColumn[] {
    let cols: UiColumn[] = [];

    var orderNumber = new UiColumn("orderNumber", "Project Name", 100);
    var benchTemplateStatus = new UiColumn("benchTemplateStatus", "Status", 150);
    var whenBenchTemplateCreated = new UiColumn("whenCreated", "When Created", 150);
    var finalSiteMac = new UiColumn("finalSiteMac", "Final Site MAC", 150);
    var deliveryInstructions = new UiColumn("deliveryInstructions", "Delivery Instructions", 150);
    var engineerEmail = new UiColumn("clientEngineerEmail", "Engineer E-mail Address", 150);

    cols.push(orderNumber, benchTemplateStatus, whenBenchTemplateCreated, finalSiteMac, deliveryInstructions, engineerEmail);

    return cols;
  }
}

